<template>
  <div class="wrap">
    <types @nodeClick="onNodeClick" />
    <items ref="itemTable" />
  </div>
</template>

<script>
export default {
  components: {
    types: () => import("./type/list.vue"),
    items: () => import("./item/list.vue"),
  },
  data() {
    return {
      current: {},
    };
  },
  methods: {
    onNodeClick(data) {
      this.$refs.itemTable.typeId = data.Code;
      this.$refs.itemTable.loadData();
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  display: grid;
  grid-template-columns: 1fr 2fr;
  height: 100%;
  grid-gap: 16px;
  :deep(.el-tree) {
    padding: 16px;
  }
}
</style>